export default {"src":"/_next/static/media/logo.5609a0e6.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};